<template>
  <div class="content contentBody">
    <div class="content-tab-box">
      <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
            v-for="(item,index) in meaulistTab.tab" :key="index">{{index}}</span>
    </div>
    <div v-for="item in meaulistTab.tab" :key="item">
      <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
    </div>
  </div>
</template>
<script>
  import accountWdrawal from "./accountWdrawal.vue";
  import accountWdrawalList from "./accountWdrawalList.vue";
  import capitalFlow from "./capitalFlow.vue";
  let tabBox = {
    // '申请提现': {property: 'accountWdrawal'},
    // '提现记录': {property: 'accountWdrawalList'},
    '资金流水': {property: 'capitalFlow'}
  }

  export default {
    name: "tkFundManage",
    components: {
      accountWdrawal,
      accountWdrawalList,
      capitalFlow
    },
    data() {
      return {
         activeName: "",
        meaulistTab: this.meaulist.meaulistGet(this, tabBox)
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "accountWdrawal";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
